export default {
  head: [
    {
      label: null,
      key: 'desc',
      col: 6,
      leftAlign: true,
    },
    {
      label: null,
      key: 'totalTime',
      col: 2,
      unit: 'h',
    },
    {
      label: null,
      key: '',
      col: 2,
      unit: 'EUR',
    },
    {
      label: null,
      key: 'totalPrice',
      col: 2,
      unit: 'EUR',
    },
  ],
  isAggregation: true,
}
